import { NgModule } from '@angular/core';
import { PossessiveNamePipe } from './possessive-name.pipe';

@NgModule({
  declarations: [PossessiveNamePipe],
  imports: [],
  exports: [PossessiveNamePipe],
  providers: [PossessiveNamePipe],
})
export class PossessiveNamePipeModule {}
